import { AuthenticatorType } from '@mews-commander/data-access';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { useCustomDocumentTitle } from '../../../../../../layouts/useCustomDocumentTitle';
import { TwoFactorAuthenticationApp } from './TwoFactorAuthenticationApp';
import { TwoFactorAuthenticationEmail } from './TwoFactorAuthenticationEmail';
import { TwoFactorAuthenticationEmailLink } from './TwoFactorAuthenticationEmailLink';

export interface TwoFactorAuthenticationProps {
    data: { type: AuthenticatorType };
}

export function TwoFactorAuthentication({ data }: TwoFactorAuthenticationProps) {
    useCustomDocumentTitle({ textKey: TextKey.Authenticate });

    const emailLinkSecondFactorEnabled = useFeatureFlag(FeatureFlag.emailLinkSecondFactorEnabled);

    if (data.type === AuthenticatorType.Email) {
        return emailLinkSecondFactorEnabled ? <TwoFactorAuthenticationEmailLink /> : <TwoFactorAuthenticationEmail />;
    }

    if (data.type === AuthenticatorType.Google) {
        return <TwoFactorAuthenticationApp />;
    }

    return <LocalizedText textKey={TextKey.FatalErrorMessage} />;
}
